import React from 'react';
// import PropTypes from 'prop-types';
import { Container, StyledSvg } from './journal-logo-small.css';

import journalHeader2 from 'images/journal/journal-2.png';

const JournalLogoSmall = () => (
  <Container to="/journal">
    <StyledSvg viewBox="0 0 484.98 188.99">
      <defs>
        <pattern
          id="journal-header-1"
          patternUnits="objectBoundingBox"
          width="1"
          height="1"
          viewBox="0 0 1307 363"
        >
          <image
            preserveAspectRatio="none"
            xlinkHref={journalHeader2}
            width="1307"
            height="363"
          />
        </pattern>
      </defs>
      <title>NDC Journal</title>
      <rect
        fill="url(#journal-header-1)"
        className="bg-brand-blue"
        x="28.79"
        width="456.19"
        height="102.81"
      />
      <path d="M53.38,96.39h3.86v64H52.48L21,114.63c-3.05-4.58-6.47-9.79-8.71-13.56.09,6.19.09,12.12.09,16.71v42.58H8.63v-64H13.4l31.44,45.73c3.06,4.59,6.47,9.8,8.72,13.48-.18-6.2-.18-12-.18-16.62Zm66.12,32c0,19.58-11,32-32,32H68.92v-64H88.23C108.54,96.39,119.5,108.79,119.5,128.38Zm-4,0c0-17.34-8.81-28.48-27.32-28.48H72.78v57H87.51C106.56,156.86,115.46,145.54,115.46,128.38ZM154.8,158.3c-15.27,0-24.52-12.13-24.52-29.92s9.25-29.92,24.52-29.92c11.5,0,20.13,6.92,22.56,19.5h3.86c-2.52-14.47-12.67-23-26.42-23-17.51,0-28.48,13.47-28.48,33.42s11,33.42,28.48,33.42c14.29,0,25.07-9.43,26.78-24.89h-3.87C176,150.39,166.84,158.3,154.8,158.3Zm88.59-16.18c0,9.89-5.93,16.18-15.46,16.18s-15.45-6.29-15.45-16.18v-3.77h-3.77v3.77c0,11.68,7.27,19.68,19.22,19.68s19.32-8,19.32-19.68V96.39h-3.86Zm54.35-4.94c0,14.38-8.44,24.26-21.11,24.26s-21-9.88-21-24.26,8.36-24.26,21-24.26S297.74,122.81,297.74,137.18Zm-3.86,0c0-12.49-6.65-20.93-17.25-20.93s-17.16,8.44-17.16,20.93,6.65,20.94,17.16,20.94S293.88,149.67,293.88,137.18Zm44,2.61c-.18,13-7.64,18.33-15.27,18.33-8.54,0-13.48-4.77-13.48-14.38V114h-3.68v30.1c0,11.23,6.11,17.34,16.53,17.34a16.7,16.7,0,0,0,16-10.87v9.79h3.59V114H337.9Zm18-14.92V114h-3.51v46.36h3.69V134.67c0-10.34,5.75-17.7,16.8-17.7.72,0,1.61,0,2.51.09v-3.51c-1.08-.09-1.88-.09-2.78-.09C363.23,113.46,358,119,355.87,124.87Zm45.91-12a16.57,16.57,0,0,0-16.09,11.15V114h-3.5v46.36h3.68V134.58c.18-13,7.64-18.33,15.28-18.33,8.53,0,13.47,4.76,13.47,14.37v29.74h3.69v-30.1C418.31,119,412.2,112.92,401.78,112.92Zm65.13,44.48c.72,0,1.53-.09,2.16-.09v3.05a24.2,24.2,0,0,1-2.79.18c-4.67,0-6.74-2.15-6.74-7.1V151.2c-3.05,6.74-9.34,10.24-18,10.24-9.88,0-15.18-5.39-15.18-13.12,0-7.45,4.58-12.31,16.17-13.74l7.46-.9c7.64-1,9.43-3.42,9.43-8.27,0-5.57-3.59-9.25-12.93-9.25-10.07,0-14.2,3.41-14.56,11.5h-3.59c.27-9.25,5.3-14.74,18.15-14.74,11.68,0,16.53,5.22,16.53,12.49v27.85C463.05,156.14,464.22,157.4,466.91,157.4Zm-7.46-24.26c-1.52,1.8-4.22,2.87-8.89,3.5l-7.46,1c-9,1.17-12.94,4.4-12.94,10.6,0,5.84,3.78,10.07,11.59,10.07,9.62,0,17.7-5.13,17.7-17.07Zm15.28,27.22h3.68v-64h-3.68Z" />
      <text
        style={{ fontSize: '89px', letterSpacing: '0em' }}
        className="font-display font-extralight"
        fill="rgba(0,0,0,0.01)"
        transform="translate(0 160.33)"
      >
        NDC Journal
      </text>
    </StyledSvg>
  </Container>
);

// JournalLogoSmall.propTypes = {
// };

export default JournalLogoSmall;
